import {
  CCReassignmentRequest,
  CCRelatedItemsResponse
} from '../../../features/UserContractCategories/types'

export const formatRelatedItems = (data: CCRelatedItemsResponse) => ({
  rfp: data.requests_for_proposal.map((rpf) => ({
    led_by: rpf,
    can_be_edited: true
  })),
  contracts: data.organization_contract_categories.map((contract) => ({
    led_by: contract,
    can_be_edited: true
  }))
})

export const prepareRelatedItems = (data: CCReassignmentRequest) => {
  const rfpList = data.assignee_set?.rfp_assignee_set ?? []
  const contractsList = data.assignee_set?.org_cc_assignee_set ?? []

  const filteredRFPList = rfpList
  const filteredContractsList = contractsList

  return {
    rfpAssignee: filteredRFPList,
    contractAssignee: filteredContractsList,
    rfp: filteredRFPList.length ? Array.from(new Set(filteredRFPList)) : [],
    contracts: filteredContractsList.length
      ? Array.from(new Set(filteredContractsList))
      : []
  }
}
